import React, { useEffect, useState } from 'react'
import { Route, Redirect } from 'react-router-dom'
import allActions from '../redux/actions/user'
import { useDispatch, useSelector } from 'react-redux'

export default function CustomRoute({ component: Component, protect, ...rest }) {

  const dispatch = useDispatch()
  const [logged, setLogged] = useState(true)
  const state = useSelector(state => state)

  // Vérifie si il y a un token stocké dans le localstorage, si oui vérifie le token dans le back puis re login l'utilisateur
  useEffect(() => {

    async function fetchData() {
      if (state.loggedIn === true) return setLogged(true)
      async function getToken() {

        const token = localStorage.getItem('accessToken')

        // Pas de token, donc pas d'utilisateur connecté
        if (!token || token === '') return false

        // Token existant, donc on vérifie si il est valide, puis login l'utilsateur
        else {

          // Vérifie la validité du token via l'api
          const result = await allActions.fetchPostAPI(`api/auth/check-token/${token}`, { test: 'test' }, dispatch)

          //Si la requête n'a pas fonctionnné une erreur est affiché
          if (result.err) return false

          //Si le serveur retourne une erreur elle est affiché
          const { json } = result
          if (json.err) return false

          //Mise à jour du state user Redux
          dispatch(allActions.setUser(json.licencie, json.accessToken))
          dispatch(allActions.logIn())

          checkDataCompleted({ ...json.licencie.additionalInfos, mail: json.licencie.mail })

          return true
        }
      }

      setLogged(await getToken())
    }

    fetchData()

  }, [state.loggedIn])

  function checkDataCompleted(info) {
    
    if(info.LICI_CIVILITE && info.LICI_NOM && info.LICI_PRENOM && info.LICI_PROF_ID && info.LICI_DATENAISS && info.LICI_ADRESSE1 && info.LICI_ADRESSE2 && info.ETAT_CODE && info.LICI_VILLE && info.LICI_TEL && info.mail && info.CNT_ID) {
      dispatch(allActions.setDataCompleted(true))
    }
    else {
      dispatch(allActions.setDataCompleted(false))
    }
    
  }


  return (
    <>{(protect) ?
      <Route {...rest} render={(props) => ((logged) ? <Component {...props} /> : <Redirect to='/login' />)} />
      :
      <Route {...rest} render={(props) => (<Component {...props} />)} />
    }</>)

}
